<template>
  <layout-content>
    <edit-form v-bind="form_data" />
  </layout-content>
</template>
<script>
  import EditForm from '@autocaller_v2/components/campaigns-edit-form.vue';
  import { mapMutations } from 'vuex';
  import { CampaignsService } from '@autocaller_v2/services/CampaignsService';
  export default {
    components: { EditForm },
    data() {
      return {
        form_data: {
          id: null,
          item: null
        }
      };
    },
    created() {
      const id = this.$route.params.id;
      this.set_campaign_id(id);

      CampaignsService.getItem(id)
        .then(item => {
          const { id } = item;
          this.form_data = { id, item };
          this.endLoadingPage();
        })
        .catch(e => this.showPageError(e));
    },

    beforeDestroy() {
      this.set_campaign_id(null);
    },

    methods: {
      ...mapMutations({
        set_campaign_id: 'autocaller_v2/campaigns/tasks/campaign_id'
      })
    }
  };
</script>
